







































import Vue from 'vue';
import SingleContactInfo from '@/components/partnershop/SingleContactInfo.vue';
import ProfileAvatar from '@/components/common/profile-avatar/ProfileAvatar.vue';
import { IPartnerShopImages, IPartnerShopInformation } from '@/common/interfaces/partnershop.interface';
import config from '../../../config';
import PartnerShopMethods from '../../methods/PartnerShopMethods';

interface IPartnerInfo {
  loading: boolean;
  partnerShopImages: IPartnerShopImages;
  partnerShopInformation: IPartnerShopInformation;
  partnerShopName: string;
}

export default Vue.extend({
  name: `PartnerInfo`,
  components: {
    ProfileAvatar,
    SingleContactInfo,
  },
  data(): IPartnerInfo {
    return {
      loading: true,
      partnerShopImages: config.partnershop.images,
      partnerShopInformation: {},
      partnerShopName: window.location.hostname.split(`.`)[0],
    };
  },
  computed: {
    displayFullName(): string {
      if(this.partnerShopInformation) {
        if(this.partnerShopInformation.firstname && this.partnerShopInformation.lastname) {
          return `${this.partnerShopInformation.firstname} ${this.partnerShopInformation.lastname}`;
        }
        if(this.partnerShopInformation.company) {
          return this.partnerShopInformation.company;
        }
      }
      return ``;
    },
    displayName(): string {
      if(this.partnerShopInformation) {
        if(this.partnerShopInformation.firstname) {
          return this.partnerShopInformation.firstname;
        }
        if(this.partnerShopInformation.company) {
          return this.partnerShopInformation.company;
        }
      }
      return ``;
    },
  },
  async mounted(): Promise<void> {
    this.loading = true;
    await this.fetchPartnerShopInformation();
    window.$swal = this.$swal;
    this.loading = false;
  },
  methods: {
    async fetchPartnerShopInformation(): Promise<void> {
      this.partnerShopInformation = await PartnerShopMethods.getPartnerShopInformation();
      if(this.partnerShopInformation && this.partnerShopInformation.phone) {
        if(this.partnerShopInformation.phone.mobile
          && this.partnerShopInformation.phone.mobile.country
          && this.partnerShopInformation.phone.mobile.dialingCode
          && this.partnerShopInformation.phone.mobile.number) {
          this.partnerShopInformation.phone.mobile.number = `${this.partnerShopInformation.phone.mobile.countryCode}
           ${this.partnerShopInformation.phone.mobile.dialingCode}
           ${this.partnerShopInformation.phone.mobile.number}`;
        }
        if(this.partnerShopInformation.phone.telephone
          && this.partnerShopInformation.phone.telephone.country
          && this.partnerShopInformation.phone.telephone.dialingCode
          && this.partnerShopInformation.phone.telephone.number) {
          this.partnerShopInformation.phone.telephone.number = `${this.partnerShopInformation.phone.telephone.countryCode}
           ${this.partnerShopInformation.phone.telephone.dialingCode}
           ${this.partnerShopInformation.phone.telephone.number}`;
        }
      }
    },
  },
});
